import {
  Grid,
  Typography,
  Container
} from "@mui/material";
import feature1 from "app/assets/images/pic1.jpg"
import feature2 from "app/assets/images/pic2.jpg"
import feature3 from "app/assets/images/pic3.jpg"
// import feature3 from "feature3.jpg"
// import AppButton from "app/components/shared/AppButton/AppButton.tsx";
// import { ButtonTypeEnum } from "app/components/shared/enums/global-enums.tsx";
import React from "react";
import "../Features/Features.scss";

export default function Features() {
  return (
    <Container >
      <div className="v-space-10"></div>
      <div className="feature-container">
        <div className="d-flex-column">
          <Typography variant="h3" className="title">
            Bespoke educational services using our unique AI-based competency framework
          </Typography>
          <div className="v-space-5"></div>
          <Typography variant="h3" className="sub-title">At Competency Edge, we are dedicated to fostering a future where students graduate not just with knowledge, but with the competencies needed to succeed and make meaningful contributions in any environment. 
            </Typography>
        </div>
        <div className="v-space-1"></div>
        <Grid container className="feature-grid-container jc-sa ai-c my-5">
          
              <div>
                <Grid container spacing={4}>

                  <Grid item xs={12} md={6} container >
                    <Grid className="feature-title">
                      1. Consulting services
                    </Grid>
                    <Grid className="feature-content " >
                      <u>Course & Program Analysis:</u>
                        <ul>
                          <li>Alignment of planned/addressed competencies to objectives, learning outcomes, accreditation requirements and employer needs</li>
                          <li>Gap analysis</li>
                          <li>Program coherence and progression of learning</li>
                        </ul>
                      <u>Course & Program co-development:</u>
                        <ul>
                          <li>Identification of improvement potential and possible measures</li>
                        </ul>
                      <u>Student learning analysis:</u>
                        <ul>
                          <li>Alignment of intended learning with students’ perceived learning of competencies</li>
                          <li>Analysis of progression</li>
                        </ul>
                      <span className="main-color font-3 bold">Target audience:</span><br/>
                      Educators and program developers at universities and schools, training organisations, and HR departments 
                    </Grid>

                  </Grid>
                  <Grid item xs={12} md={6} className="img-1" container >
                    <div style={{width:'100%', backgroundRepeat: 'no-repeat', height: '100%', backgroundSize: 'cover', backgroundImage:"url("+feature1+")"}}></div>
                  </Grid>
                </Grid>
              </div>

              
              <div className="v-space-10"></div>
              <div className="v-space-10"></div>


              <div>
                <Grid container spacing={4}>
                  <Grid item xs={12} md={6}   className="img-1 disp-desktop"  container >
                    <div style={{width:'100%', backgroundRepeat: 'no-repeat', height: '100%', backgroundSize: 'cover', backgroundImage:"url("+feature2+")"}}></div>
                  </Grid>

                  <Grid item xs={12} md={6} container >
                    <Grid className="feature-title">
                      2. Hands-on competency workshops
                    </Grid>
                    <Grid className="feature-content " >
                      <u>Competency identification and mapping</u> 
                      <ul>
                        <li>Introduction to competencies</li>
                        <li>Identification and formulation of competencies for one’s own course</li>
                      </ul>
                        
                      <u>Competency Gap analysis</u> 
                      <ul>
                        <li>Identification of misalignment of competencies and learning outcomes at course and program level</li>
                      </ul>

                      <u>Course & program improvement measures</u> 
                      <ul>
                        <li>Identification of improvement potential and possible measures</li>
                      </ul>

                      <span className="main-color font-3 bold">Target audience:</span><br/>
                      Educators, program developers, trainers, accreditation institutions representatives, future employers 


                    </Grid>
                  </Grid>
                  
                  <Grid item xs={12} md={6}   className="img-1 disp-mobile"  container >
                    <div style={{width:'100%', backgroundRepeat: 'no-repeat', height: '100%', backgroundSize: 'cover', backgroundImage:"url("+feature2+")"}}></div>
                  </Grid>

                </Grid>
              </div>


              <div className="v-space-10"></div>
              <div className="v-space-10"></div>

              <div>
                <Grid container spacing={4}>

                  <Grid item xs={12} md={6} container >
                    <Grid className="feature-title">
                      3. Design approaches workshops
                    </Grid>
                    <Grid className="feature-content " >
                      Introduction of design methods to foster design competencies in design and non-design courses.<br/>

                      <div className="v-space-10"></div>
                      <span className="main-color font-3 bold">Target audience:</span><br/>
                      Educators interested in developing a design course or are interested in introducing a designerly approach in their non-design course

                    </Grid>
                  </Grid>
                  <Grid item xs={12} md={6} className="img-1 " container >
                    <div style={{width:'100%', backgroundRepeat: 'no-repeat', height: '100%', backgroundSize: 'cover', backgroundPosition: 'center', backgroundImage:"url("+feature3+")"}}></div>
                  </Grid>
                </Grid>
              </div>
            
        </Grid>
      </div>
    </Container>
  );
}
